export default {
  home: '/home',
  settings: '/settings',
  fuelBot: '/fuelbot',
  kpi: '/kpi',
}
